// @flow
import type { Selector } from '../../core/types'
import { hget } from '../../modules/hash'
import {
  UI,
  TABS,
  IS_MAIN_MENU_OPEN,
  IS_USER_MENU_OPEN,
  IS_CURRENT_BIDS_OPEN,
  IS_FILTERS_OPEN,
  CURRENT_FILTER
} from './constants'

export const isMainMenuOpen: Selector<boolean> = hget(UI, IS_MAIN_MENU_OPEN)
export const isUserMenuOpen: Selector<boolean> = hget(UI, IS_USER_MENU_OPEN)
export const isCurrentBidsOpen: Selector<boolean> = hget(
  UI,
  IS_CURRENT_BIDS_OPEN
)
export const isFiltersOpen: Selector<boolean> = hget(UI, IS_FILTERS_OPEN)
export const currentFilter: Selector<boolean> = hget(UI, CURRENT_FILTER)

export const getTabIndex = (tabName: string, state: any): Selector<number> =>
  hget(UI, `${TABS}.${tabName}`, state)



// WEBPACK FOOTER //
// ./src/services/layout/selectors.js